import React, { useEffect } from 'react';
import { Route, Switch, useLocation, Redirect  } from 'react-router';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import Form from '../Pages/Form/Form';
import CarteTp from '../Pages/CarteTp/CarteTp';
import Hospitalisation from '../Pages/Hospitalisation/Hospitalisation';
import Resiliation from '../Pages/Resiliation/Resiliation';
import Profile from '../Pages/Profile/Profile';
import Remboursement from './../Pages/Remboursement/Remboursement';
import Affiliation from './../Pages/Affiliation/Affiliation';
import ListDocument from '../Pages/ListDocument/ListDocument';
import SendDocument from '../Pages/SendDocument/SendDocument';
import ListTypeDocument from '../Pages/ListTypeDocument/ListTypeDocument';
import DocumentGaranties from '../Pages/DocumentGaranties/DocumentGaranties';
import Actuality from './../Pages/Actuality/Actuality';
import Partenaire from './../Pages/Partenaire/Partenaire';
import Dispense from './../Pages/dispense/dispense';
import Home from './../Pages/home/home';
import Setting from '../Pages/Setting/Setting';
import Notification from '../Pages/Notification/Notification';
import HealthService from '../Pages/HealthService/HealthService';
import Contact from '../Pages/Contact/Contact';
import ResetPasswordMail from '../Pages/ResetPasswordMail/ResetPasswordMail';
import ResetPassword from '../Pages/ResetPassword/ResetPassword';
import SimulateurDeRemboursement from '../Pages/SimulateurDeRemboursement/SimulateurDeRemboursement';
import DocumentSended from '../Pages/DocumentSended/DocumentSended';
import SelectPractitionerType from '../Pages/Geolocation/SelectPractitionerType/SelectPractitionerType';
import SetGeolocation from '../Pages/Geolocation/SetGeolocation/SetGeolocation';
import GetGeolocatedPractitioners from '../Pages/Geolocation/GetGeolocatedPractitioners/GetGeolocatedPractitioners';
import convertContenSquareList from '../Json/ContentSquareTranslation.json';
import Store from '../Redux/Store';
import Contracts from '../Pages/Contracts/Contracts';

const MainRoute = () => {
  const location = useLocation();
  // useEffect hook to track URL changes
  useEffect(() => {
    if (
      Store.getState()?.auth?.user?.contractTypes &&
      !Store.getState()?.auth?.user?.contractTypes.includes('SANTE')
    ) {
      const elem = document.getElementById('chatbot-insert');
      if (elem && elem.classList) {
        elem.remove();
      }
    }
    let localContenSquareData = localStorage.getItem('ContenSquareData');
    if (localContenSquareData && localContenSquareData != '[object, object]') {
      localContenSquareData = JSON.parse(localContenSquareData);
    }
    console.log('localContenSquareData', localContenSquareData);
    if (localContenSquareData) {
      const indexOfSquareData = window.dataLayer.findIndex(
        (elem) => elem.env_id == 'monespaceassure SPVIE'
      );
      const sentLocationList = [];
      if (location.search && location.search != '') {
        const locationParams = location.search.substring(1).split('&');
        if (locationParams[0].split('=')[0] == 'topCategory') {
          sentLocationList.push('/' + locationParams[0].split('=')[1]);
        } else {
          sentLocationList.push(location.pathname);
          for (let index = 0; index < locationParams.length; index++) {
            const localParams = locationParams[index].split('=');
            console.log(localParams[1]);
            if (convertContenSquareList[localParams[1]]) {
              sentLocationList.push(convertContenSquareList[localParams[1]]);
            } else {
              sentLocationList.push(localParams[1]);
            }
          }
        }
      } else {
        sentLocationList.push(location.pathname);
      }
      console.log('Contensquare Sent Route', sentLocationList.join('/'));
      if (indexOfSquareData > -1) {
        window.dataLayer[indexOfSquareData] = {
          ...localContenSquareData,
          funnel_step: sentLocationList.join('/')
        };
      } else {
        window.dataLayer.push({
          ...localContenSquareData,
          funnel_step: sentLocationList.join('/')
        });
      }
      console.log('window.dataLayer', window.dataLayer);
    } else {
      console.log('not possible for setting ContenSquareData with new url');
      console.log(localContenSquareData);
    }
  }, [location]);
  return (
    <Switch>
      {/* <Route
        exact
        path="/redirect/to"
        component={(props) => {
          const redirectTo = (url) => (window.location.href = url);
          const params = new URLSearchParams(props.location.search);
          const webUrl = params.get('url');
          const mobileUrl = params.get('url_mobile');

          redirectTo(mobileUrl);

          const now = Date.now();
          setTimeout(() => {
            if (Date.now() - now < 400) {
              redirectTo(webUrl);
            }
          }, 200);
          return <div>redirect</div>;
        }}
      /> */}
      <PrivateRoute exact path="/" component={Home} />
      <Route exact path="/dispense" component={Dispense} />

      {/* LOGIN ROUTES */}
      <Route exact path="/login" render={() => <Redirect to="/welcome" />} />
      {/* <Route exact path="/FirstLogin" component={FirstLogin} />
      <Route
        exact
        path="/FirstLogin/:token"
        component={FirstLoginCreateAccount}
      /> */}
      <Route exact path="/ResetPasswordMail" component={ResetPasswordMail} />
      <Route exact path="/ResetPassword/*" component={ResetPassword} />

      {/*  DOCUMENTS ROUTES */}
      <PrivateRoute exact path="/documents" component={ListDocument} />
      <PrivateRoute exact path="/documents/send" component={SendDocument} />
      <PrivateRoute exact path="/documents/contracts" component={Contracts} />

      <PrivateRoute
        exact
        path="/documents/listDocument/"
        component={ListTypeDocument}
      />
      <PrivateRoute
        exact
        path="/documents/listDocument/:type"
        component={ListTypeDocument}
      />
      <PrivateRoute exact path="/documents/sended" component={DocumentSended} />

      <PrivateRoute exact path="/Hospitalisation" component={Hospitalisation} />

      <PrivateRoute
        exact
        path="/geolocation/select"
        component={SelectPractitionerType}
      />

      <PrivateRoute
        exact
        path="/geolocation/set-location"
        component={SetGeolocation}
      />

      <PrivateRoute
        exact
        path="/geolocation/results"
        component={GetGeolocatedPractitioners}
      />

      <PrivateRoute exact path="/Profile" component={Profile} />
      <PrivateRoute exact path="/Remboursement" component={Remboursement} />
      <PrivateRoute exact path="/consommation" component={Remboursement} />
      <Route exact path="/Affiliation" component={Affiliation} />

      <PrivateRoute exact path="/garanties" component={DocumentGaranties} />
      <PrivateRoute exact path="/actuality" component={Actuality} />
      <PrivateRoute exact path="/partenaire" component={Partenaire} />
      <PrivateRoute exact path="/setting" component={Setting} />
      <PrivateRoute exact path="/healthservice" component={HealthService} />
      <PrivateRoute exact path="/contact" component={Contact} />
      <PrivateRoute exact path="/termination" component={Resiliation} />

      <PrivateRoute exact path="/Form" component={Form} />
      <PrivateRoute exact path="/Cartetp" component={CarteTp} />
      <PrivateRoute
        exact
        path="/SimulateurDeRemboursement"
        component={SimulateurDeRemboursement}
      />
      {window.innerWidth < 768 && (
        <PrivateRoute exact path="/notification" component={Notification} />
      )}
    </Switch>
  );
};

export default MainRoute;
